import React, { useEffect, useState } from "react";
import { getbudgetalerts } from "../../../../services/admin";
import { toast } from "react-toastify";
import moment from "moment";

export default function BudgetAlerts() {
    const [alertData, setAlertData] = useState(null);
    const [loading, setLoading] = useState(false);
    const branchId = localStorage.getItem("branch") || "";

    useEffect(() => {
        fetchAlerts();
    }, []);

    const fetchAlerts = () => {
        setLoading(true);
        const params = branchId ? { branch_id: branchId } : {};
        getbudgetalerts(params).then((res) => {
            if (res.status === true) {
                setAlertData(res.data);
            } else {
                toast.error(res.message || "Failed to fetch alerts");
            }
            setLoading(false);
        });
    };

    const refreshAlerts = () => {
        fetchAlerts();
        toast.success("Alerts refreshed");
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Budget Alerts</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Accounts</a>
                    </li>
                    <li className="breadcrumb-item">
                        <a>Budget</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Budget Alerts
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4 className="card-title">
                                                <i className="fa fa-exclamation-triangle"></i> Budget Alerts
                                            </h4>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            <button className="btn btn-primary" onClick={refreshAlerts}>
                                                <i className="fa fa-refresh"></i> Refresh
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}

                            {alertData && !loading && (
                                <>
                                    {/* Summary Cards */}
                                    <div className="row mb-4">
                                        <div className="col-md-3 d-flex">
                                            <div className="card bg-danger text-white w-100">
                                                <div className="card-body d-flex flex-column">
                                                    <h6><i className="fa fa-bell"></i> Critical Alerts</h6>
                                                    <h2 className="mb-2">{alertData.summary.critical_count}</h2>
                                                    <small className="mt-auto">Budgets exceeded or at limit</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 d-flex">
                                            <div className="card bg-warning text-white w-100">
                                                <div className="card-body d-flex flex-column">
                                                    <h6><i className="fa fa-exclamation-circle"></i> Warnings</h6>
                                                    <h2 className="mb-2">{alertData.summary.warning_count}</h2>
                                                    <small className="mt-auto">Approaching budget limit</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 d-flex">
                                            <div className="card bg-info text-white w-100">
                                                <div className="card-body d-flex flex-column">
                                                    <h6><i className="fa fa-money"></i> Total Budgeted</h6>
                                                    <h2 className="mb-2" style={{ fontSize: '1.5rem' }}>₹ {parseFloat(alertData.summary.total_budgeted).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</h2>
                                                    <small className="mt-auto">&nbsp;</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-3 d-flex">
                                            <div className="card bg-dark text-white w-100">
                                                <div className="card-body d-flex flex-column">
                                                    <h6><i className="fa fa-arrow-up"></i> Total Overrun</h6>
                                                    <h2 className="mb-2" style={{ fontSize: '1.5rem' }}>₹ {parseFloat(alertData.summary.total_overrun).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</h2>
                                                    <small className="mt-auto">&nbsp;</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Critical Alerts */}
                                    {alertData.critical_alerts.length > 0 && (
                                        <div className="card border-danger mb-4">
                                            <div className="card-header bg-danger text-white">
                                                <h5><i className="fa fa-exclamation-triangle"></i> Critical Alerts ({alertData.critical_alerts.length})</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>Account</th>
                                                                <th>Branch</th>
                                                                <th>Period</th>
                                                                <th className="text-end">Budgeted</th>
                                                                <th className="text-end">Actual</th>
                                                                <th className="text-end">Overrun</th>
                                                                <th className="text-center">Utilization</th>
                                                                <th className="text-center">Action Required</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {alertData.critical_alerts.map((alert, idx) => (
                                                                <tr key={idx} className="table-danger">
                                                                    <td>
                                                                        <strong>{alert.account_name}</strong>
                                                                    </td>
                                                                    <td>{alert.branch_name}</td>
                                                                    <td>{alert.period_name}</td>
                                                                    <td className="text-end">
                                                                        ₹ {parseFloat(alert.budgeted_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <strong className="text-danger">
                                                                            ₹ {parseFloat(alert.actual_spending).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                        </strong>
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <strong className="text-danger">
                                                                            ₹ {parseFloat(Math.abs(alert.variance)).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                        </strong>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <div className="progress" style={{ height: '25px' }}>
                                                                            <div
                                                                                className="progress-bar bg-danger"
                                                                                role="progressbar"
                                                                                style={{ width: '100%' }}
                                                                            >
                                                                                {parseFloat(alert.utilization_percentage).toFixed(1)}%
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span className="badge bg-danger">
                                                                            {alert.variance < 0 ? 'OVER BUDGET' : 'AT LIMIT'}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Warnings */}
                                    {alertData.warnings.length > 0 && (
                                        <div className="card border-warning mb-4">
                                            <div className="card-header bg-warning text-white">
                                                <h5><i className="fa fa-exclamation-circle"></i> Warnings ({alertData.warnings.length})</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>Account</th>
                                                                <th>Branch</th>
                                                                <th>Period</th>
                                                                <th className="text-end">Budgeted</th>
                                                                <th className="text-end">Actual</th>
                                                                <th className="text-end">Remaining</th>
                                                                <th className="text-center">Utilization</th>
                                                                <th className="text-center">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {alertData.warnings.map((warning, idx) => (
                                                                <tr key={idx} className="table-warning">
                                                                    <td>
                                                                        <strong>{warning.account_name}</strong>
                                                                    </td>
                                                                    <td>{warning.branch_name}</td>
                                                                    <td>{warning.period_name}</td>
                                                                    <td className="text-end">
                                                                        ₹ {parseFloat(warning.budgeted_amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <strong className="text-warning">
                                                                            ₹ {parseFloat(warning.actual_spending).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                        </strong>
                                                                    </td>
                                                                    <td className="text-end">
                                                                        <strong className="text-success">
                                                                            ₹ {parseFloat(warning.variance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                                                        </strong>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <div className="progress" style={{ height: '25px' }}>
                                                                            <div
                                                                                className="progress-bar bg-warning"
                                                                                role="progressbar"
                                                                                style={{ width: `${Math.min(warning.utilization_percentage, 100)}%` }}
                                                                            >
                                                                                {parseFloat(warning.utilization_percentage).toFixed(1)}%
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span className="badge bg-warning">
                                                                            APPROACHING LIMIT
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* No Alerts Message */}
                                    {alertData.critical_alerts.length === 0 && alertData.warnings.length === 0 && (
                                        <div className="alert alert-success">
                                            <h5><i className="fa fa-check-circle"></i> All Clear!</h5>
                                            <p>No budget alerts at this time. All budgets are within acceptable limits.</p>
                                        </div>
                                    )}

                                    {/* Recommendations */}
                                    {(alertData.critical_alerts.length > 0 || alertData.warnings.length > 0) && (
                                        <div className="alert alert-info">
                                            <h6><i className="fa fa-lightbulb-o"></i> Recommended Actions:</h6>
                                            <ul className="mb-0">
                                                {alertData.critical_alerts.length > 0 && (
                                                    <>
                                                        <li><strong>For Critical Alerts:</strong> Review spending immediately and consider budget revision or spending freeze</li>
                                                        <li>Analyze transactions to identify unnecessary expenses</li>
                                                        <li>Request budget increase if spending is justified and necessary</li>
                                                    </>
                                                )}
                                                {alertData.warnings.length > 0 && (
                                                    <>
                                                        <li><strong>For Warnings:</strong> Monitor spending closely for the remainder of the period</li>
                                                        <li>Defer non-essential expenses if possible</li>
                                                        <li>Plan for next period to avoid overruns</li>
                                                    </>
                                                )}
                                                <li>Set up automated email notifications for budget thresholds</li>
                                                <li>Review budget allocations quarterly for adjustments</li>
                                            </ul>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
